import { getFieldLabelColumn } from '@modules/quantify/hooks/useExportQuantifyReportDataAsCSV/helpers/getFieldLabelColumn';
import { QuantifyQuery } from '@modules/quantify/store/types';
import { isAggregateFormula } from '@modules/quantify/utils';
import { CsvColumnType } from 'generated/graphql';
import { EQLFunctionName } from 'v2/core/repository/eql/types';

interface getBreakdownColumnsParams {
  formulaID: EQLFunctionName;
  groupBy: QuantifyQuery['groupBy'];
  formulaDisplayName?: string;
  shouldRemoveFileUploadPrefix: boolean;
  isUnifiedFieldEnabled: boolean;
}

export function getBreakdownColumns({
  formulaID,
  groupBy,
  formulaDisplayName,
  shouldRemoveFileUploadPrefix,
  isUnifiedFieldEnabled,
}: getBreakdownColumnsParams) {
  const shouldShowFloatingValue = formulaID !== EQLFunctionName.Count;

  const getTitle = () => {
    if (isAggregateFormula(formulaID)) {
      return formulaDisplayName ?? '';
    }

    return formulaID === EQLFunctionName.NormaliseByPercent
      ? 'Feedback Percentage'
      : 'Feedback Count';
  };

  return [
    ...(isAggregateFormula(formulaID)
      ? []
      : [
          getFieldLabelColumn({
            groupBy,
            shouldRemoveFileUploadPrefix,
            isUnifiedFieldEnabled,
          }),
        ]),
    {
      title: getTitle(),
      type: shouldShowFloatingValue
        ? CsvColumnType.Float
        : CsvColumnType.Integer,
    },
  ];
}
